// extracted by mini-css-extract-plugin
module.exports = {"footerRoot":"GXETODLu","hasScroll":"tIEl7o0d","footerText":"twQH_BQH","styledButtonLink":"DHHj3jT8"};